import { render } from "./SpiritOfJapan.vue?vue&type=template&id=30b97c49&scoped=true"
import script from "./SpiritOfJapan.vue?vue&type=script&lang=js"
export * from "./SpiritOfJapan.vue?vue&type=script&lang=js"

import "./SpiritOfJapan.scss?vue&type=style&index=0&id=30b97c49&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b97c49"]])

export default __exports__